import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, Hidden, Button, CircularProgress } from '@material-ui/core'
import { styled } from '@material-ui/core/styles';

import Moment from 'moment'
import 'moment/locale/fr';

import APIS from "../../../utils/APIS"
import progressionKeys from "../../../utils/progressionKeys"


import SelectEcoleMenuMobile from "./SelectEcoleMenuMobile"
import MyPopover from "../MyPopover"

import { Header, CardContainer, FiltersDisplay, FilterList, ItemPopover  } from "./Suivi"
import { ModalTuto } from "./Home"

import ProgressionChart from "./ProgressionChart"


import UserAdminClientContext from "../../../contexts/UserAdminClientContext"
import LanguageContext from "../../../contexts/LanguageContext"

import moyenneIcon from "../../../images/moyenneIcon.svg"
import modulesIcon from "../../../images/modulesIcon.svg"
import moyenneTempsIcon from "../../../images/moyenneTempsIcon.svg"
import etudiantsTotIcon from "../../../images/etudiantsTotIcon.svg"
import searchIcon from "../../../images/searchIcon.svg"
import filterIcon from "../../../images/filterIcon.svg"
import cardIcon from "../../../images/cardIcon.svg"
import sablierIcon from "../../../images/sablierIcon.svg"
import progressionUpArrow from "../../../images/progressionUpArrow.svg"
import progressionDownArrow from "../../../images/progressionDownArrow.svg"
import progressionStableArrow from "../../../images/progressionStableArrow.svg"



Moment.locale('fr')

const ActionList = ({ filters, setFilters, icebreakerQuestions }) => {
  const {
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [actItem, setActItem] = useState(null)
  const menuOpenClose = (item) => {
    if (item === actItem) {
      setActItem(null)
    } else {
      setActItem(item)
    }
  }

  return (
    <Box sx={{display:"flex", alignItems:"flex-start"}}>
      <Box sx={{
        minWidth:"220px",
        maxWidth:"350px",
        padding:"10px 20px",
        boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
        border: "1px solid rgba(206, 206, 206, 0.5)",
        borderRadius: "6px",
        background:"white",
      }}>
        {actEcole?.groupes?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.groupe[actLanguage]}
              onClick={() => {menuOpenClose("groupe")}} selected={actItem === "groupe"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "groupe" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                  datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                  onlyOneSelection={true}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.secteurs === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.sector[actLanguage]}
              onClick={() => {menuOpenClose("secteur")}} selected={actItem === "secteur"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "secteur" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                  datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {actEcole?.campus?.length > 1 &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.campus[actLanguage]}
              onClick={() => {menuOpenClose("campus")}} selected={actItem === "campus"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "campus" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                  datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.diplome === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.graduationYear[actLanguage]}
              onClick={() => {menuOpenClose("diplome")}} selected={actItem === "diplome"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "diplome" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                  datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
        {icebreakerQuestions?.annees === true &&
          <>
            <ItemPopover
              title={languageValues?.adminDashboard?.filters?.studyYear[actLanguage]}
              onClick={() => {menuOpenClose("etude")}} selected={actItem === "etude"} icon={filterIcon}
            />
            <Hidden mdUp>
              {actItem === "etude" &&
                <FilterList
                  title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                  datas={icebreakerQuestions.diplomeReps}
                  filterType="anneesEtude" filters={filters} setFilters={setFilters}
                />
              }
            </Hidden>
          </>
        }
      </Box>
      <Hidden mdDown>
        {actItem !== null &&
          <Box sx={{
            marginLeft:"10px",
            maxWidth:"350px",
            minWidth:"200px",
            padding:"10px 20px",
            boxShadow: "0 0 20px 0 rgba(0, 0, 0, 0.15)",
            border: "1px solid rgba(206, 206, 206, 0.5)",
            borderRadius: "6px",
            background:"white",
          }}>
            {actItem === "groupe" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.groupeSub[actLanguage]}
                datas={actEcole?.groupes} dataToDisplay={["diplome", "name"]} dataToCheck="groupeID" filterType="groupes" filters={filters} setFilters={setFilters}
                onlyOneSelection={true}
              />
            }
            {actItem === "campus" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.campusSub[actLanguage]}
                datas={actEcole?.campus} dataToDisplay={"name"} dataToCheck="id" filterType="campus" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "secteur" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.sectorSub[actLanguage]}
                datas={icebreakerQuestions.secteursReps} filterType="secteur" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "diplome" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.graduationYearSub[actLanguage]}
                datas={icebreakerQuestions.anneesReps} filterType="anneesDiplome" filters={filters} setFilters={setFilters}
              />
            }
            {actItem === "etude" &&
              <FilterList
                title={languageValues?.adminDashboard?.filters?.studyYearSub[actLanguage]}
                datas={icebreakerQuestions.diplomeReps} filterType="anneesEtude" filters={filters} setFilters={setFilters}
              />
            }
          </Box>
        }
      </Hidden>
    </Box>
  )
}

let defautFilters = {
  groupes : [],
  campus : [],
  secteur : [],
  anneesEtude : [],
  anneesDiplome : []
}

const Progression = ({ }) => {

  const {
    ecoles,
    actEcole,
  } = useContext(UserAdminClientContext)
  const { actLanguage, languageValues } = useContext(LanguageContext)

  const [seeTuto, setSeeTuto] = useState(false)

  const [dataLoaded, setDataLoaded] = useState(false)
  const [glbData, setGlbData] = useState(null)

  const [seuilsGraph, setSeuilsGraph] = useState(null)
  const [graphsData, setGraphsData] = useState([])

  const [filteredData, setFilteredData] = useState([])
  const [filteredStat, setFilteredStat] = useState({})
  const [filters, setFilters] = useState(defautFilters)

  const [popoverFilters, setPopoverFilters] = useState(false)
  const popoverRef = useRef()



  useEffect(() => {
    setDataLoaded(false)
    if (actEcole?.groupes?.length > 0) {
      let fetchData = []
      actEcole?.groupes?.forEach((g) => {
        if (g.icebreaker !== null) {
          let ids = []
          let planByDate = JSON.parse(JSON.stringify(g?.plan?.plan)).sort(function(a,b){
            return new Date(a.closeDate) - new Date(b.closeDate);
          });
          planByDate?.forEach((p) => {
            ids.push(p.id)
          })
          fetchData.push({
            groupeID : g.groupeID,
            ids : ids,
            icebreaker : g.icebreaker
          })
        }
      })
      if (fetchData.length > 0) {
        APIS.clientAdminMapping({fetchData : fetchData}).then((result) => {
          if (result?.value?.length > 0) {
            let finalData = {
              contents : [],
              results : [],
              contentsPerGroup : [],
              nbrUsersTotal : 0
            }
            result?.value?.forEach((d) => {
              if (d.isOk === true && d.contents && d.results && d.users) {
                finalData.nbrUsersTotal += d.nbrUsersTotal

                d.contents.forEach((content) => {
                  content.groupeID = d?.groupeID
                  finalData.contents.push(content)
                })
                d.results.forEach((result) => {
                  //on va chercher ce user
                  let findUser = d?.users?.find((el) => el.id === result.userID)
                  result.groupeID = d?.groupeID
                  result.campusID = findUser?.campusID
                  finalData.results.push(result)
                })

                finalData?.contentsPerGroup?.push({
                  groupeID : d?.groupeID,
                  contents : d?.contents
                })
              }
            })


            //if (actEcole?.groupes?.length > 1) {
              setFilters({...filters,
                groupes : [actEcole?.groupes[0]?.groupeID]
              });
            //}

            setGlbData(finalData)
            setDataLoaded(true)
          } else {
            setDataLoaded(false)
          }
        })
      }
    }
  }, [actEcole])

  useEffect(() => {
    if (glbData !== null && glbData.results && glbData.results.length > 0 && glbData.contents && glbData.contents.length > 0) {
      let newStats = {}
      let filtered = []
      let duplicateSkills = []
      let resultsForGraph = []
      //on regarde pour trouver des softskills présents dans plusieurs formations
      let actGroupe = actEcole?.groupes?.find((el) => el.groupeID === filters.groupes[0])
      let contentsForThisGroup = glbData?.contentsPerGroup?.find((el) => el.groupeID === filters.groupes[0])
      if (contentsForThisGroup && contentsForThisGroup?.contents?.length >= 0) {
        //stats
        newStats.nbrModules = contentsForThisGroup?.contents?.length
        let totalTime = 0
        contentsForThisGroup?.contents?.forEach((content) => {
          totalTime += content?.timing || 0
        })
        newStats.averageTime = parseInt(totalTime / newStats.nbrModules)

        //on va regarder les résultats
        filtered = glbData.results
        if (filters.groupes.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.groupes.includes(el.groupeID)
          })
        }
        if (filters.campus.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.campus.includes(el.campusID)
          })
        }
        if (filters.secteur.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.secteur.includes(el.userResult_ice?.secteurs)
          })
        }
        if (filters.anneesEtude.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.anneesEtude.includes(el.userResult_ice?.diplome)
          })
        }
        if (filters.anneesDiplome.length !== 0) {
          filtered = filtered.filter((el) => {
            return filters.anneesDiplome.includes(el.userResult_ice?.annees)
          })
        }

        //pour graph, niveau de connaissance
        filtered.forEach((result) => {
          if (result["resultFin_ice"]) {
            let actResult = result["resultFin_ice"]
            if (actResult[progressionKeys?.start]) {
              resultsForGraph.push({
                userID : result?.userID,
                startScore : actResult[progressionKeys?.start]?.score || 0
              })
            }
          }
        })

        //calcul moyenne groupe
        let arrResults = []
        contentsForThisGroup?.contents?.forEach((content) => {
          arrResults.push("resultFin_"+content.id)
        })
        newStats.etudiantTot = filtered?.length
        let nbrResult = 0
        let totalResult = 0
        filtered.forEach((result) => {
          arrResults.forEach((resultKey) => {
            if (result[resultKey]) {
              let actResult = result[resultKey]
              if (actResult?.glbMaster?.score >= 0) {
                nbrResult += 1
                totalResult += actResult?.glbMaster?.score
              } else if (actResult?.master?.score >= 0) {
                nbrResult += 1
                totalResult += actResult?.master?.score
              }
              //on regarde pour le niveau de connaissance de fin si on le trouve
              if (actResult[progressionKeys?.end]) {
                let findInResultsForGraph = resultsForGraph?.find((el) => el?.userID === result?.userID)
                if (findInResultsForGraph) {
                  findInResultsForGraph.endScore = actResult[progressionKeys?.end]?.score || 0
                }
              }
            }
          })
        })
        if (nbrResult > 0) {
          newStats.moyenne = parseInt(totalResult / nbrResult)
        } else {
          newStats.moyenne = "-"
        }

        //on trie pour graph, niveau de connaissance : on enlève si on a pas un startScore et un endScore
        resultsForGraph = resultsForGraph.filter((el) => el.startScore >= 0 && el.endScore >= 0)
      }

      //recherche pour liste des skills
      if (contentsForThisGroup && contentsForThisGroup?.contents?.length >= 2) {//il faut au moins 2 modules pour pouvoir comparer
        //on fait un tableau avec tous les skills de tous les modules de ce groupe
        let skillsPerContent = []
        contentsForThisGroup?.contents?.forEach((content) => {
          let contentIndexInPlan = actGroupe?.plan?.plan?.findIndex((el) => el.id === content.id)
          let skills = content?.softSkills?.filter((el) => el.value === "oui")
          skills.forEach((skill) => {
            skillsPerContent.push({
              key : skill.key,
              contentID : content.id,
              contentIndex : contentIndexInPlan,
            })
          })
        })

        //on regarde si on trouve des skills à comparer
        skillsPerContent.forEach((skill) => {
          let countThisSkill = skillsPerContent?.filter((el) => el.key === skill.key)
          if (countThisSkill?.length >= 2) {
            //on regarde si on le connait déjà
            let find = duplicateSkills.find((el) => el.key === skill.key)
            if (!find) {
              countThisSkill = countThisSkill?.sort((a, b) => {
                if (a.contentIndex < b.contentIndex) {
                  return -1;
                }
                if (a.contentIndex > b.contentIndex) {
                  return 1;
                }
                return 0;
              })
              duplicateSkills.push({
                key : skill.key,
                first : countThisSkill[0],
                last : countThisSkill[countThisSkill?.length - 1]
              })
            }
          }
        })

        //pour chaque skill, on va chercher les résultats de chaque user et on fait une moyenne avant / après
        duplicateSkills.forEach((skill) => {
          let totalFirst = 0
          let nbrFirst = 0
          let totalLast = 0
          let nbrLast = 0

          filtered.forEach((result) => {
            let resultFirst = result["resultFin_"+skill?.first?.contentID]
            if (resultFirst[skill?.key]?.score >= 0) {
              totalFirst += resultFirst[skill?.key]?.score
              nbrFirst += 1
            }

            let resultLast = result["resultFin_"+skill?.last?.contentID]
            if (resultLast[skill?.key]?.score >= 0) {
              totalLast += resultLast[skill?.key]?.score
              nbrLast += 1
            }
          })

          skill.first.nbr = nbrFirst
          skill.first.total = totalFirst
          if (nbrFirst > 0) {
            skill.first.moyenne = totalFirst / nbrFirst
          } else {
            skill.first.moyenne = 0
          }

          skill.last.nbr = nbrLast
          skill.last.total = totalLast
          if (nbrLast > 0) {
            skill.last.moyenne = totalLast / nbrLast
          } else {
            skill.last.moyenne = 0
          }
        })

        //on va calculer la progression
        duplicateSkills.forEach((skill) => {
          skill.progression = Math.round( (skill?.last?.moyenne - skill?.first?.moyenne) * 100 ) / 100
        })

        //on trie en fonction de la progression, de la plus grande vers la plus petite
        duplicateSkills = duplicateSkills?.sort((a, b) => {
          if (a.progression > b.progression) {
            return -1;
          }
          if (a.progression < b.progression) {
            return 1;
          }
          return 0;
        })
        //console.log(duplicateSkills)
      }

      //on calcule pour le graph
      let tranchesGraph = [
        { label: "0/4.9", max : 5, students : [] },
        { label: "5/14.9", max : 15, students : [] },
        { label: "15/49.9", max : 50, students : [] },
        { label: "50/84.9", max : 85, students : [] },
        { label: "85/94.9", max : 95, students : [] },
        { label: "95/100", max : 101, students : [] } //on triche pour le 100 car juste "<"
      ]
      if (resultsForGraph?.length > 0) {
        //on met les élèves dans chaque tranche
        resultsForGraph?.forEach((result) => {
          let find = tranchesGraph.find((t) => result?.startScore < t.max) //ici on défini si on prend le startScore ou le endScore pour mettre dans les tranches
          if (find) {
            find.students.push(result)
          }
        })

        //pour chaque tranche, on calcul le nbr d'élèves, le startScore total, la moyenne startScore, le endScore total, et la moyenne endScore
        tranchesGraph.forEach((t) => {
          if (t?.students?.length > 0) {
            t.nbrStudents = t.students.length
            let totalStartScore = 0
            let totalEndScore = 0
            t?.students?.forEach((student) => {
              totalStartScore += student?.startScore || 0
              totalEndScore += student?.endScore || 0
            })

            t.totalStartScore = totalStartScore
            t.moyStartScore = t.totalStartScore / t.nbrStudents
            t.totalEndScore = totalEndScore
            t.moyEndScore = t.totalEndScore / t.nbrStudents
            t.progression = t.moyEndScore - t.moyStartScore
          } else {//pas d'élève
            t.nbrStudents = 0
            t.totalStartScore = 0
            t.moyStartScore = 0
            t.totalEndScore = 0
            t.moyEndScore = 0
            t.progression = 0
          }
        })

      }

      //on regarde pour le certification
      let seuilsForKnowledgeLevel = {
        before : 0,
        after : 0,
        find : false,
      }
      let certificationForKnowledge = null
      if (actEcole?.groupes?.length === 1) {
        certificationForKnowledge = actEcole?.groupes[0]?.certification
      } else if (actEcole?.groupes?.length > 1) {
        let actGroupeFilterID = filters.groupes[0]
        certificationForKnowledge = actEcole?.groupes?.find((el) => el.groupeID === actGroupeFilterID)?.certification
      }
      if (certificationForKnowledge) {
        let find = certificationForKnowledge.find((el) => el.id === "valuesForNiveauConnaissance")
        if (find) {
          seuilsForKnowledgeLevel = {
            before : find?.before || 0,
            after : find?.after || 0,
            find : true,
          }
        }
      }

      setSeuilsGraph(seuilsForKnowledgeLevel)
      setGraphsData(tranchesGraph)

      setFilteredData(duplicateSkills)
      setFilteredStat(newStats)
    }
  }, [glbData, filters, actEcole])



  return (
    <>
      <Hidden smUp>
        <SelectEcoleMenuMobile />
      </Hidden>

      <ModalTuto
        isOpen={seeTuto}
        onClose={() => {
          setSeeTuto(false)
        }}
        title={languageValues?.adminDashboard?.mappingPage?.tutoTitle[actLanguage]}
        subTitle={languageValues?.adminDashboard?.mappingPage?.tutoSubTitle[actLanguage]}
        videoUrl={null}
      />

      <Box
        sx={{
          flex:1,
          padding:["20px", "50px", "50px", "80px"],
          backgroundColor:"background.grey",
        }}
      >
        <Header
          title={languageValues?.adminDashboard?.mapping[actLanguage]}
          dataLoaded={dataLoaded && glbData !== null && filteredData.length !== 0}
          withTuto
          onClickTuto={() => { setSeeTuto(true) }}
        />

        <Box sx={{
          display:"flex",
          width:"100%",
          flexDirection:["column", "column", "column", "row"],
          columnGap:"30px",
          rowGap:"15px",
        }}>
          <Box sx={{
            flex:0.6,
            background: "white",
            border:"1px solid #E7E7E7",
            height:["280px", "300px", "300px", "315px"],
            minHeight:["280px", "300px", "300px", "315px"],
            overflow:"hidden",
            paddingTop:["20px", "30px"],
            paddingBottom:["20px", "30px"],
            paddingRight:["20px", "30px"],
            paddingLeft:["20px", "20px"],
          }}>
            <ProgressionChart data={graphsData} seuils={seuilsGraph}/>
          </Box>
          <Box sx={{
            flex:0.4,
            display:"flex",
            flexWrap:"wrap",
            gap:["15px","15px","15px","20px"]
          }}>
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.average[actLanguage]} unit="&nbsp;/100"
              value={filteredStat.moyenne !== undefined ? filteredStat.moyenne : "-"} icon={moyenneIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.time[actLanguage]} unit="&nbsp;MIN"
              value={filteredStat.averageTime !== undefined ? filteredStat.averageTime : "-"} icon={moyenneTempsIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.students[actLanguage]}
              value={filteredStat.etudiantTot !== undefined ? filteredStat.etudiantTot : "-"} icon={etudiantsTotIcon} dataLoaded={dataLoaded}
            />
            <CardContainer
              forMapping
              title={languageValues?.adminDashboard?.monitoringCards?.modules[actLanguage]}
              value={filteredStat.nbrModules !== undefined ? filteredStat.nbrModules : "-"} icon={modulesIcon} dataLoaded={dataLoaded}
            />
          </Box>
        </Box>

        {(dataLoaded && glbData !== null) ? (
          <>
            <Box sx={{
              display:"flex",
              gap:"10px",
              justifyContent:"space-between",
            }}>
              <Box sx={{
                marginTop:"35px",
                display:"flex",
                gap:["8px", "8px", "15px", "15px"],
                flexDirection:["column", "column", "row", "row"],
                alignItems:"flex-start",
              }}>
                <Button
                  ref={popoverRef}
                  disabled={!dataLoaded}
                  variant="contained"
                  disableRipple
                  sx={{
                    height:"40px !important",
                    minHeight:"40px !important",
                    flexShrink:0,
                    textTransform:"none",
                    background:"white",
                    color:"text.black",
                    boxShadow:"none",
                    border:"1px solid #E7E7E7",
                    fontSize:"14px !important",
                    gap:"8px",
                    '&:hover': {
                      background:"white",
                      border:"1px solid black",
                    },
                  }}
                  onClick={() => { setPopoverFilters(true) }}
                >
                  <img src={searchIcon} style={{width:"14px"}} />
                  <span>
                    {languageValues?.adminDashboard?.filters?.addFilter[actLanguage]}
                  </span>
                </Button>
                <FiltersDisplay isMapping filters={filters} setFilters={setFilters} contents={glbData.contents} defaultF={defautFilters}/>
              </Box>
            </Box>

            <Box sx={{
              marginTop:"25px",
              display:"flex",
              flexDirection:"row",
              flexWrap:"wrap",
              columnGap:"20px",
              rowGap:"10px",
            }}>
              {filteredData?.map((skill, index) => {
                return (
                  <SkillCard
                    key={index}
                    name={skill?.key}
                    result={skill?.progression}
                  />
                )
              })}

            </Box>

            <MyPopover
              isDrawerOpen={popoverFilters}
              anchorEl={popoverRef.current}
              handleClose={() => { setPopoverFilters(false) }}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            >
              <ActionList
                glbData={glbData}
                filters={filters}
                setFilters={setFilters}
                icebreakerQuestions={actEcole?.icebreakerQuestions}
              />
            </MyPopover>
          </>
        ) : (
          <Box sx={{flex:1, marginTop:"80px", display:"flex", alignItems:"center", justifyContent:"center"}}>
            <CircularProgress size="70px" sx={{'color': 'black'}} />
          </Box>
        )}


      </Box>

    </>
  )
}

const SkillCard = ({ name, result }) => {

  const { actLanguage, languageValues } = useContext(LanguageContext)

  return (
    <Box sx={{
      flexBasis:["100%", "100%", "100%", "calc(50% - 10px)"],
      background:"white",
      border:"1px solid #E7E7E7",
      height:["65px", "70px", "70px", "95px"],
      minHeight:["65px", "70px", "70px", "95px"],
      padding:["10px", "12px", "12px", "20px"],
      display:"flex",
      justifyContent:"space-between",
      gap:["10px", "15px", "15px", "20px"],
      alignItems:"center",
      overflow:"hidden"
    }}>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["8px", "11px", "11px", "15px"],
        overflow:"hidden"
      }}>
        <Box sx={{
          width:["37px", "40px", "40px", "50px"],
          minWidth:["37px", "40px", "40px", "50px"],
          overflow:"hidden",
          aspectRatio:1,
        }}>
          <img src={cardIcon} style={{width:"100%"}}/>
        </Box>
        <Box sx={{
          whiteSpace:"noWrap",
          textOverflow:"ellipsis",
          overflow:"hidden",
          color:"text.black",
          fontSize:["16px", "18px", "18px", "22px"],
          textTransform:"capitalize",
        }}>
          {name}
        </Box>
      </Box>
      <Box sx={{
        display:"flex",
        alignItems:"center",
        gap:["6px", "8px", "8px", "10px"],
        overflow:"hidden",
        flexShrink:0,
      }}>
        {(result >= 0 || result <= 0) ? (
          <>
            <Box sx={{
              display:"flex",
              alignItems:"center",
              position:"relative",
              width:["60px", "75px", "75px", "95px"],
              minWidth:["60px", "75px", "75px", "95px"],
              marginRight:"10px",
              userSelect:"none",
            }}>
              {(result >= -1 && result <= 1) &&
                <img src={progressionStableArrow} style={{width:"100%"}}/>
              }
              {result < -1 &&
                <img src={progressionDownArrow} style={{width:"100%"}}/>
              }
              {result > 1 &&
                <img src={progressionUpArrow} style={{width:"100%"}}/>
              }
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["16px", "20px", "20px", "26px"],
              minWidth:["55px", "65px", "65px", "85px"],
              textAlign:"right"
            }}>
              {result > 0 && "+"}
              {result}%
            </Box>
          </>
        ) : (
          <Box sx={{
            display:"flex",
            gap:["6px", "8px", "8px", "8px"],
            alignItems:"center",
          }}>
            <Box sx={{
              width:["10px", "12px", "12px", "14px"],
              minWidth:["10px", "12px", "12px", "14px"],
              overflow:"hidden",
              aspectRatio:"14/17.22"
            }}>
              <img src={sablierIcon} style={{width:"100%"}}/>
            </Box>
            <Box sx={{
              color:"text.black",
              fontSize:["13px", "14px", "14px", "16px"]
            }}>
              {languageValues?.formation?.pending[actLanguage]}
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default Progression
